module.exports = __webpack_public_path__ + "static/media/12-ball.a9df5d71.png";